import { useEffect, useState } from 'react';

const TOAST_DURATION_MS = 3000;
let nextId = 1;

// Gọi ở bất kỳ đâu: toast('Đã lưu thay đổi')
export function toast(message) {
  window.dispatchEvent(new CustomEvent('toast', { detail: { id: nextId++, message } }));
}

// Đặt một lần trong App để hiện các thông báo
export function Toaster() {
  const [toasts, setToasts] = useState([]);

  useEffect(() => {
    const onToast = (e) => {
      const item = e.detail;
      setToasts((list) => [...list, item]);
      setTimeout(() => setToasts((list) => list.filter((t) => t.id !== item.id)), TOAST_DURATION_MS);
    };
    window.addEventListener('toast', onToast);
    return () => window.removeEventListener('toast', onToast);
  }, []);

  const dismiss = (id) => setToasts((list) => list.filter((t) => t.id !== id));

  return (
    <div className="toasts" role="status" aria-live="polite">
      {toasts.map((t) => (
        <div key={t.id} className="toast" onClick={() => dismiss(t.id)}>
          <span className="toast-icon">✓</span>
          {t.message}
          <span className="toast-bar" style={{ animationDuration: `${TOAST_DURATION_MS}ms` }} />
        </div>
      ))}
    </div>
  );
}

// Vòng xoay giữa màn hình khi trang đang tải dữ liệu (nằm trên khung xương)
export function LoadingSpinner({ label = 'Đang tải…' }) {
  return (
    <div className="page-spinner" role="status" aria-live="polite">
      <span className="page-spinner-ring" aria-hidden="true" />
      <span className="page-spinner-label">{label}</span>
    </div>
  );
}

// Khối xám lấp lánh giữ chỗ khi nội dung chưa tải xong
export function Skeleton({ width, height, radius = 6, style }) {
  return <span className="skeleton" style={{ width, height, borderRadius: radius, ...style }} aria-hidden="true" />;
}
